<icon
  fill="{props.fill || 'none'}"
  stroke="{props.stroke || 'currentColor'}"
  stroke-width={props.strokeWidth || 1.5}
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <use href="/assets/images/feather-sprite.svg#{props.name}"/>
</icon>